import Swiper, {Navigation, Pagination} from 'swiper';
import Vivus from 'vivus';
import vars from '../helpers';

const sliderInit = () => {
	const textbookSlider = document.querySelector('.textbook__items');
	const textbookPopupSlider = document.querySelector('.popup#textbook .popup__items');
	const newsSlider = document.querySelector('.news__items');
	const moduleSlider = document.querySelector('.module__container');
	const moduleSlide1 = document.querySelector('.module__slide--1');
	const modulePagination = document.querySelector('.module__pagination');
	const moduleSliderSpeed = 0.5;

	const moduleSwiper = new Swiper(moduleSlider, {
		speed: moduleSliderSpeed * 1000,
		spaceBetween: 0,
		slidesPerView: 'auto',
		autoHeight: true,
		modules: [Pagination],
		pagination: {
			el: '.module__pagination',
			clickable: true,
			renderBullet: (index, className) => {
				let name = document.querySelector('.module__pagination').getAttribute(`data-pagination${index + 1}`);

				return `<span class=${className} data-pagination="${name}"></span>`;
			},
		},
		breakpoints: {
			1025: {
				autoHeight: false,
				direction: 'vertical',
			},
		},
		on: {
			slideChangeTransitionEnd: (slider) => {
				if (vars.isDesktop()) {
					let moduleSlideBg = new Vivus(document.querySelector(`#bg-${slider.activeIndex + 1}`), {
						start: 'manual',
						type: 'sync',
						duration: 50,
					});

					moduleSlideBg.play();
				}
			},
		},
	});

	const textbookSwiper = new Swiper(textbookSlider, {
		speed: 500,
		spaceBetween: 10,
		slidesPerView: 1.25,
		breakpoints: {
			1025: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				enabled: false
			}
		},
		modules: [Pagination, Navigation],
		pagination: {
			el: '.textbook__pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.textbook__slide-next'
		}
	});

	const textbookPopupSwiper = new Swiper(textbookPopupSlider, {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Navigation],
		breakpoints: {
			768: {
				slidesPerView: 2,
			}
		},
		navigation: {
			prevEl: '.popup__items-prev',
			nextEl: '.popup__items-next',
		}
	})

	const newsSwiper = new Swiper(newsSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Pagination],
		pagination: {
			el: '.news__pagination',
			clickable: true,
		},
	});

	const observers = new IntersectionObserver((entries, observer) => {
		entries.forEach((section) => {
			if (section.isIntersecting) {
				observer.unobserve(section.target);

				moduleSwiper.slideNext(moduleSliderSpeed * 1000);
				gsap.delayedCall(moduleSliderSpeed, () => {
					moduleSlide1.classList.add('is-animate');
					modulePagination.classList.add('is-animate');
				});
			}
		});
	}, {threshold: 0.6});

	observers.observe(document.querySelector('.module'));
};

export default sliderInit;
